<form [formGroup]="reportListForm" class="report-list" (ngSubmit)="onSubmit()">
  <mat-card class="mat-card-report-list">
    <mat-card-header>
      <mat-card-title>{{ 'report-list.title' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-card-content-report-list">

      <div class="content-row">
        <label class="content-row-label">{{ 'report-list.report-category' | translate}}</label>
        <mat-form-field class="content-row-input">
          <mat-select formControlName="category">
            <mat-option *ngFor="let category of categories" [value]="category">
              {{category}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'report-list.report-type' | translate}}</label>
        <!-- <mat-form-field class="content-row-input">
          <input type="text" [placeholder]="placeHolder" aria-label="Number" matInput formControlName="type"
            [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let report of filteredReports | async" [value]="report">
              {{report?.name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field> -->

        <mat-form-field class="content-row-input">
          <mat-select formControlName="type">
            <mat-option *ngFor="let report of reportsByCategory" [value]="report">
              {{report?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="content-row" *ngIf="reportListForm.get('type')?.value?.year">
        <label class="content-row-label">{{ 'label.year' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="year" type="number" autocomplete="off">
        </mat-form-field>
      </div>

      <div class="content-row" *ngIf="reportListForm.get('type')?.value?.startDate">
        <label class="content-row-label">{{ 'label.beginDate' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput [matDatepicker]="startDateReport" formControlName="startDate" autocomplete="off" [min]="uiService.getMinDate()"
          [max]="uiService.getMaxDate()">
          <mat-datepicker-toggle matSuffix [for]="startDateReport"></mat-datepicker-toggle>
          <mat-datepicker #startDateReport [disabled]="reportListForm.get('startDate')?.disabled"></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="content-row" *ngIf="reportListForm.get('type')?.value?.endDate">
        <label class="content-row-label">{{ 'label.endDate' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput [matDatepicker]="endDateReport" formControlName="endDate" autocomplete="off" [min]="uiService.getMinDate()"
          [max]="uiService.getMaxDate()">
          <mat-datepicker-toggle matSuffix [for]="endDateReport"></mat-datepicker-toggle>
          <mat-datepicker #endDateReport [disabled]="reportListForm.get('endDate')?.disabled"></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="content-row" *ngIf="reportListForm.get('type')?.value?.site">
        <label class="content-row-label">{{ 'label.site' | translate}}</label>
        <app-site-list [control]="$any(reportListForm).controls['site']" class="content-row-input"></app-site-list>
      </div>

      <div class="content-row" *ngIf="reportListForm.get('type')?.value?.company">
        <label class="content-row-label">{{ 'label.company' | translate}}</label>
        <app-company-list [control]="$any(reportListForm).controls['company']" class="content-row-input">
        </app-company-list>
      </div>

      <div class="content-row" *ngIf="reportListForm.get('type')?.value?.material">
        <label class="content-row-label">{{ 'label.material' | translate}}</label>
        <app-material-list [control]="$any(reportListForm).controls['material']" class="content-row-input">
        </app-material-list>
      </div>

    </mat-card-content>
    <mat-card-actions class="report-list-card-action">
      <button mat-raised-button color="primary" [disabled]="reportListForm.invalid">
        <mat-icon>file_copy</mat-icon> {{ 'button.download-report' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</form>